module.exports = __webpack_public_path__ + "static/logo-9041e7b85195548acd0759bd87172895.png";